<template>
  <div>
    <header class="header-main">
      <div class="containers">
        <div class="logo-header">
          <router-link to="/home" :class="getActiveTabClass('/home')">
            <img :src="getTranslations.project_logo_img" alt="">
          </router-link>
        </div>
        <nav class="main-nav main-nav--home">
          <a :href="getTranslations.project_my_orange_link"
             target="_blank"
             :class="['my_orange', getTranslations.project_my_orange_logo ? '': 'hide']">
            <img :src="getTranslations.project_my_orange_logo" alt="">
          </a>
          <ul :class="['main-nav__list', (hideStore)? 'nav_nostore': '']">
            <li>
              <router-link to="/home" :class="getActiveTabClass('/home')"><img :src="getTranslations.project_home_icon" alt=""></router-link>
            </li>
            <li class="hidden-tb-up">
              <router-link to="/home/profile" :class="['avatar', getActiveTabClass('/home/profile')]"><img :src="userAvatar" alt=""></router-link>
            </li>
            <li :class="[(hideStore)? 'store_hide': '']">
              <router-link to="/home/store" :class="getActiveTabClass('/home/store')" style="cursor:pointer"><img :src="getTranslations.project_store_icon" alt=""></router-link>
            </li>
            <li>
              <router-link to="/home/notifications" :class="['icon-bubble', getActiveTabClass('/home/notifications')]" style="cursor:pointer">
                <img :src="getTranslations.project_bell_icon" alt=""><span v-if="numberOfUnreadNotifications > 0">{{ numberOfUnreadNotifications
                }}</span></router-link>
            </li>
            <li><router-link to="/home/howitworksLoggedIn"  style="cursor:pointer"><img :src="getTranslations.project_how_it_works_icon" alt=""></router-link></li>
            <li @click.prevent="goToProfilePage" class="hidden-tb-down">
              <a :class="['avatar', getActiveTabClass('/home/profile')]"><img
                :src="userAvatar" alt=""><span
                class="hidden-lg-down" style="cursor:pointer">{{ userDetails.username }}</span></a>
            </li>
          </ul>
          <button data-menu="nav_dropdown" class="nav__toggle nav__toggle--home"><span></span></button>
          <div id="nav_dropdown" :class="[isIos ? 'ios' : 'nav-dropdown']" >
            <ul>
              <li v-if="!hideLeaderboard">
                <router-link to="/home/prizesAndLeaderBoards" :class="getActiveTabClass('/home/prizesAndLeaderBoards')">
                  {{ getTranslations.home_home_prizes_and_leaderboards }}
                </router-link>
              </li>
              <li v-if="!hideWinners">
                <router-link to="/home/winners" :class="getActiveTabClass('/home/winners')">{{ getTranslations.home_home_winners }}</router-link>
              </li>
              <!--<li>-->
              <!--<router-link to="/home/achievemgetTranslation :class="getActiveTabClass('/home/achievemgetTranslation')">{{ getTranslations.home_home_achievements) }}-->
              <!--</router-link>-->
              <!--</li>-->
              <li>
                <router-link to="/home/settings" :class="getActiveTabClass('/home/settings')">{{ getTranslations.home_home_settings }}</router-link>
              </li>
              <li>
                <router-link to="/home/howitworksLoggedIn" :class="getActiveTabClass('/home/howitworksLoggedIn')">{{ getTranslations.home_home_how_it_works }}</router-link>
              </li>
            </ul>
            <div class="nav-dropdown__buttons">
              <a @click.prevent="logout"
                 v-if="hasLogout()"
                 class="btn btn--small btn--outline"
                 style="cursor:pointer">{{ getTranslations.home_home_log_out }}</a>
              <a @click.prevent="playGame"
                 class="btn btn--small btn--white"
                 style="cursor:pointer">{{ getTranslations.home_home_new_game }}</a>
              <div class="clearfix"></div>
            </div>
          </div>
        </nav>
      </div>
    </header>

    <router-view :playGame="playGame"></router-view>
    <div :class="currentTabPath ==='/home'?'black-overlay':''" ></div>

    <!--modal for resume game-->
    <component :is="currentModal"></component>

    <!-- dynamically change modals -->
    <component :is="modalForHomePage"></component>


  </div>
</template>


<script>
/* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import Vue from 'vue';
import { handleBurgerButton, closeTab } from '@/common/jQuery';
import NewGameMixin from '@/common/mixins/home';
import RoundUpMixin from '@/common/mixins/roundUp';
import IntegrationMixin from '@/common/mixins/integration';
import webSocket from '@/common/webSocket';
import auth from '@/common/auth';
import ResumeGame from './modals/ResumeGame';
import ResubscribeGame from './modals/ResubscribeGame';
import ResubscribeGameSms from './modals/ResubscribeGameSms';
import ZeroBalance from './modals/ZeroBalance';
import WelcomeSignup from './modals/WelcomeSignup';

const moment = require('moment');

Vue.use(require('vue-moment'), {
  moment,
});

export default {
  name: 'home',
  mixins: [NewGameMixin, RoundUpMixin, IntegrationMixin],
  data() {
    return {
      stompClient: null,
      subscription: null,
      connectionTimer: null,
      isIos: false,
      currentTabPath: null,
      unreadNotifications: 0,
      newButtonClicked: false,
      showedModal: false,
      currentModal: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.currentTabPath === null && to.path === '/home') {
        vm.currentTabPath = to.path;
        sessionStorage.setItem('homeCurrentTabPath', vm.currentTabPath);
      }
    });
  },
  beforeRouteUpdate(to, from, next) {
    // eslint-disable-next-line
    $(window).scrollTop(0);
    console.log(`from: ${from.path}`);
    console.log(`to: ${to.path}`);
    this.currentTabPath = to.path;
    this.currentModal = null;
    console.log(`-------------------------------------- beforeRouteUpdate: ${this.currentTabPath} + ${sessionStorage.getItem('homeCurrentTabPath')} + ${to.path} `);
    sessionStorage.setItem('homeCurrentTabPath', to.path);
    closeTab();
    this.newButtonClicked = false;
    this.webSocketConnectAndReceiveServerResponse(); // only in beforeUpdate for the case where the game is finished and no reload process has been done
    next();
  },
  created() {
    // eslint-disable-next-line
    if (this.integrationHeader === this.availableIntegrations.KOREK_IRAQ.name && (sessionStorage.getItem('isRun') === null || sessionStorage.getItem('isRun') === 'false')) {
      if (document.getElementById('db_response')) {
        document.removeChild('korek_response');
        document.removeChild('db_response');
      }
      sessionStorage.setItem('isRun', 'true');
    }
    this.currentTabPath = sessionStorage.getItem('homeCurrentTabPath');
    console.log(`-------------------------------------- created hook: ${this.currentTabPath} `);
    console.log('Home\'s created hook');
    console.log('this.userDetails:', this.userDetails);
    this.isIos = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    this.getUserNotifications().then(() => {
      // example url for extra Notifications from SocketJS -- http://localhost:8181/api/sendNotifications?msisdn=300136987410
      this.stompClient = webSocket.getNotificationsStompClient();
      if (this.stompClient === null) {
        this.stompClient = webSocket.createNewStompClient('/notificationsData');
      }
      /* const connect = () => {
        this.stompClient.connect({ Authorization: auth.getJwt() }, stompSuccess, stompFailure);
      };
      const stompSuccess = (frame) => {
        clearTimeout(this.connectionTimer);
        // eslint-disable-next-line
        console.log(`In Home component: ${frame}`);
        console.log(`Inside Created ${this.userDetails.msisdn}`);
        console.log(`Subscribing to channel: /topic/notifications/${this.userDetails.msisdn}`);
        this.subscription = this.stompClient.subscribe(`/topic/notificationsData/${this.userDetails.msisdn}`, (response) => {
          console.log('==> Inside notification response');
          const notificationsDTO = JSON.parse(response.body);
          this.storeNotificationsFromSocket({ notifications: notificationsDTO });
          console.log('notificationsDTO');
          console.log(notificationsDTO);
        }, (errorResponse) => { // error callback
          console.log('errorResponse');
          console.log(errorResponse);
        });
      };
      const stompFailure = (error) => {
        // console.clear();
        console.log(error);
        console.error('Lost connection to WebSocket! Reconnecting in 3 seconds...');
        clearTimeout(this.connectionTimer);
        this.connectionTimer = setTimeout(() => {
          this.stompClient = webSocket.createNewStompClient('/notificationsData');
          connect();
        }, 3000);
      };
      connect(); */
      this.connect();
    });
  },
  mounted() {
    console.log(`-------------------------------------- Mounted hook: ${this.userDetails.availableGames}`);
    this.$nextTick(() => {
      handleBurgerButton(ZeroBalance);
    });
    this.autoCheckIfGameToResumeExists();
//    this.webSocketConnectAndReceiveServerResponse();
  },
  updated() {
    // eslint-disable-next-line
    console.log('Username from db: ' + this.userDetails.username + ' username from Storage: ' + localStorage.getItem('username')
      + ' jwtToken From LocalStorage: ' + localStorage.getItem('jwtToken')
      + ' jwtToken From SessionStorage' + sessionStorage.getItem('jwtToken'));
    if (this.userDetails.username !== '') {
      // eslint-disable-next-line
      console.log('Home.js for skip refresh case');
      if (!((localStorage.getItem('username') === this.userDetails.username))
        && (localStorage.getItem('jwtToken') !== null && sessionStorage.getItem('jwtToken') === null)) {
        // eslint-disable-next-line
        console.log('Inside Case with Multiple Users...');
        // eslint-disable-next-line
        window.location.reload();
      }
      if (localStorage.getItem('jwtToken') !== null && sessionStorage.getItem('jwtToken') !== null) {
        // eslint-disable-next-line
        console.log('Inside Case with Multiple Users LOCAL & STORAGE...');
        sessionStorage.clear();
        // eslint-disable-next-line
        window.location.reload();
      }
    }
  },
  methods: {
    ...mapMutations('common', [
      'storeUserAvailableGames',
      'storeModalForHomePage',
    ]),
    ...mapMutations('profile', [
      'storeNotificationsFromSocket',
      'setFirstTimeEntry',
      'clearAllData',
    ]),
    ...mapActions('game', [
      'checkIfGameToResumeExists',
    ]),
    ...mapActions('profile', [
      'getUserNotifications',
    ]),
    hasLogout() {
      const activeIntegration = this.getIntegrationByName();
      return !activeIntegration || !activeIntegration.value.disableLogout;
    },
    autoCheckIfGameToResumeExists() {
      this.checkIfGameToResumeExists().then(() => {
        console.log('this.gameInProgress:', this.gameInProgress);
        if (this.gameInProgress) {
          console.log('showing resume game pop up...');
          this.currentModal = ResumeGame;
          this.$nextTick(() => {
            /* eslint-disable */
            // open modal
            $('.modal,.modal-overlay').fadeIn(200);
            // hide modal
            $('.modal-close, .modal-overlay').click(() => {
              /* eslint-enable */
              this.currentModal = null;
            });
          });
        } else {
          this.methodForPopUps();
        }
      }).catch(error => console.error(error));
    },
    methodForPopUps() {
      /* eslint-disable */
      if (this.firstTimeEntry) {
        this.storeModalForHomePage(WelcomeSignup);
        this.showModal();
      } else {
        const nowDate = new Date(moment().format('L'));
        const latestLogin = new Date(sessionStorage.getItem('zeroBalancePopUp'));
        if (((nowDate.getTime() > latestLogin.getTime()) || sessionStorage.getItem('zeroBalancePopUp') === null) && (this.userDetails.availableGames === 0 && this.userDetails.subscribed )&& (sessionStorage.getItem('homeCurrentTabPath') === '/home')) {
          this.storeModalForHomePage(ZeroBalance);
          this.showModal();
          sessionStorage.setItem('zeroBalancePopUp', moment().format('L'));
        }
        if (!this.userDetails.subscribed && (!this.gameInProgress) && sessionStorage.getItem('homeCurrentTabPath') === '/home') {
          if (this.subAndUnsubViaSMS) {
            if (this.reoptinAndOptoutConfig === 'REOPTIN_SMS' || this.reoptinAndOptoutConfig === 'REOPTIN_OPTOUT_SMS') {
              this.storeModalForHomePage(ResubscribeGameSms);
            } else {
              this.storeModalForHomePage(ResubscribeGame);
            }
          } else {
            this.storeModalForHomePage(ResubscribeGame);
          }
          this.showModal();
        }
      }
    },
    connect() {
      this.stompClient.connect({ Authorization: auth.getJwt() }, this.stompSuccess, this.stompFailure);
    },
    stompSuccess(frame) {
      clearTimeout(this.connectionTimer);
      // eslint-disable-next-line
      console.log(`In Home component: ${frame}`);
      console.log(`Inside Created ${this.userDetails.msisdn}`);
      console.log(`Subscribing to channel: /topic/notifications/${this.userDetails.msisdn}`);
      this.subscription = this.stompClient.subscribe(`/topic/notificationsData/${this.userDetails.msisdn}`, (response) => {
        console.log('==> Inside notification response');
        const notificationsDTO = JSON.parse(response.body);
        this.storeNotificationsFromSocket({ notifications: notificationsDTO });
        console.log('notificationsDTO');
        console.log(notificationsDTO);
      }, (errorResponse) => { // error callback
        console.log('errorResponse');
        console.log(errorResponse);
      });
    },
    stompFailure(error) {
      // console.clear();
      console.log(error);
      console.error('Lost connection to WebSocket! Reconnecting in 3 seconds...');
      clearTimeout(this.connectionTimer);
      this.connectionTimer = setTimeout(() => {
        this.stompClient = webSocket.createNewStompClient('/notificationsData');
        this.connect();
      }, 3000);
    },
    showModal() {
      /* eslint-disable */
      this.$nextTick(() => {
        // vm for instance of vue, and in it, the this is for window so the next line is necessary
        // open modal
        $('.modal,.modal-overlay').fadeIn(200);
        // show/hide modal
        $('.modal-close, .modal-overlay').click(() => {
          $('.modal, .modal-overlay').fadeOut();
          if (this.firstTimeEntry) {
            this.setFirstTimeEntry(false);
            this.storeModalForHomePage(null);
            this.methodForPopUps();
          } else {
            if (!this.showedModal) {
              console.log("----------------------- Correct Exit For  Store showHideModal");
              this.showedModal = true;
              this.storeModalForHomePage(null);
            } else {
              this.storeModalForHomePage(null);
            }
          }
        });
      });
      /* eslint-enable */
    },
    webSocketConnectAndReceiveServerResponse() {
      this.stompClient = webSocket.getGameBalanceStompClient();
      if (this.stompClient === null) {
        this.stompClient = webSocket.createNewStompClient('/gameBalanceData');
      }
      const connect = () => {
        this.stompClient.connect({ Authorization: auth.getJwt() }, stompSuccess, stompFailure);
      };
      const stompSuccess = (frame) => {
        clearTimeout(this.connectionTimer);
        console.log(`In Home component: ${frame}`);
        console.log(`Subscribing to channel: /topic/gameBalanceData/${this.userDetails.msisdn}`);
        this.subscription = this.stompClient.subscribe(`/topic/gameBalanceData/${this.userDetails.msisdn}`, (response) => {
          const availableGames = JSON.parse(response.body);
          console.log('availableGames:', availableGames);
          this.storeUserAvailableGames({ availableGames });
        }, (errorResponse) => { // error callback
          console.log('errorResponse');
          console.log(errorResponse);
        });
      };
      const stompFailure = (error) => {
        // console.clear();
        console.log(error);
        console.error('Lost connection to WebSocket! Reconnecting in 3 seconds...');
        clearTimeout(this.connectionTimer);
        this.connectionTimer = setTimeout(() => {
          this.stompClient = webSocket.createNewStompClient('/gameBalanceData');
          connect();
        }, 3000);
      };
      connect();
    },
    goToProfilePage() {
      this.$router.push('/home/profile');
    },
    logout() {
      let currentLocale = localStorage.getItem('locale');
      if (currentLocale === undefined || currentLocale === null) {
        currentLocale = this.getLocale;
      }
      const soundsOn = localStorage.getItem('soundsOn');
      localStorage.clear();
      localStorage.setItem('locale', currentLocale);
      localStorage.setItem('soundsOn', soundsOn);
      sessionStorage.clear();
      if (this.userDetails.availableGames === 0) {
        // in order to know the last log in time
        sessionStorage.setItem('zeroBalancePopUp', moment().format('L'));
      }
      this.clearAllData();
      window.location.reload();
      this.$router.push('/');
    },
    getActiveTabClass(path) {
      return this.currentTabPath === path ? 'active' : '';
    },
  },
  computed: {
    ...mapState('common', [
      'hideLeaderboard',
      'logoOnFooter',
      'hidePrizePage',
      'userAvatar',
      'userDetails',
      'subAndUnsubViaSMS',
      'reoptinAndOptoutConfig',
      'modalForHomePage',
      'hideStore',
      'hideWinners',
      'multiOperatorInfo',
      'integrationHeader',
      'availableIntegrations',
    ]),
    ...mapState('game', [
      'gameInProgress',
    ]),
    ...mapState('profile', [
      'firstTimeEntry',
      'notifications',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getLocale',
      'getTranslationByOperator',
    ]),
    numberOfUnreadNotifications() {
      /* eslint-disable */
      this.unreadNotifications = 0;
      for (let i = 0; i < this.notifications.length; i += 1) {
        if (this.notifications[i].readStatus === false) {
          this.unreadNotifications += 1;
        }
      }
      return this.unreadNotifications;
      /* eslint-enable */
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/Home.vue